import { App } from '../AppManager';

interface ThemeConfigGeneratorOptions {
  appData: App;
}

// Generate theme configuration file content
export const generateThemeConfig = ({ appData }: ThemeConfigGeneratorOptions): { content: string; filename: string } => {
  let themeConfig: any;
  let filename: string;

  if (appData.theme?.custom) {
    // Custom theme - save as theme-config.json
    themeConfig = {
      customTheme: appData.theme.custom
    };
    filename = 'theme-config.json';
  } else {
    // Default theme - save as default-theme.json
    themeConfig = {
      defaultTheme: appData.theme?.variant || 'modern-light'
    };
    filename = 'default-theme.json';
  }

  const content = JSON.stringify(themeConfig, null, 2);
  
  return {
    content,
    filename
  };
};

export const generateThemeConfigFile = (options: ThemeConfigGeneratorOptions): { content: string; filename: string } => {
  return generateThemeConfig(options);
};